import { HEIGHTS } from '../constants';

/**
 * @async
 * @returns {Promise<boolean>}
 */
export const isHD = async () => window.innerHeight < HEIGHTS.fullHD;

/**
 * @async
 * @returns {Promise<boolean>}
 */
export const isFullHD = async () => window.innerHeight >= HEIGHTS.fullHD;

/**
 * Compares the vertical resolution of the device screen against a given vertical resolution
 *
 * @async
 * @param {number} resolution Vertical resolution
 * @returns {Promise<boolean>}
 */
export const isGreaterOrEqual = async resolution => window.innerHeight >= resolution;

/**
 * Return the UHD capability
 *
 * @async
 * @return {Boolean} Return the UHD Capability type, false if undetectable or not implemented
 */
export const isUHD = async () => false;

/**
 * Return the HDR capability
 *
 * @async
 * @return {Boolean} Return the HDR Capability type, false if undetectable or not implemented
 */
export const isHDR = async () => false;

/**
 * Return the dolby vision capability
 *
 * @async
 * @return {Boolean} Return the Dolby Vision Capability type, false if undetectable or not implemented
 */
export const isDolbyVision = async () => false;
